import React, { useState } from 'react';
import { Select, SelectItem } from '@upgrade/react-components';
import { LOCALES, useLocale, useLocaleSwitcherExperiment } from '../../../utils/locale';
import LocaleMenuLabel from './LocaleMenuLabel';
import LocaleSwitcherModal from './LocaleSwitcherModal';

const LocaleSwitcherDropdown = () => {
  const { isExperimentEnabled } = useLocaleSwitcherExperiment();
  const { locale: currentLocale } = useLocale();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLocale, setSelectedLocale] = useState(currentLocale);
  const locales = Object.values(LOCALES);

  if (!isExperimentEnabled) {
    return null;
  }

  return (
    <>
      <Select
        value={currentLocale}
        onChange={(e, value) => {
          setSelectedLocale(value);
          setModalVisible(true);
        }}
        label={<LocaleMenuLabel locale={currentLocale} bold padding="none" />}
        size="normal"
        buttonProps={{ 'aria-label': 'Select a language' }}
      >
        {locales.map(locale => {
          return (
            <SelectItem key={locale.code} label={<LocaleMenuLabel locale={locale} padding="none" />} value={locale} />
          );
        })}
      </Select>
      <LocaleSwitcherModal visible={modalVisible} onClose={() => setModalVisible(false)} locale={selectedLocale} />
    </>
  );
};

export default LocaleSwitcherDropdown;
